function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Fill-1",
  d: "M78.407,20.079H69.668L74.037,12.8ZM55.963,17.818,60.332,25.1H51.593Zm19.512-6.269L80.313,10.2a.937.937,0,0,0-.5-1.807L73.8,10.069l-7.859,2.183V1.938a.937.937,0,1,0-1.875,0V12.772l-8.34,2.317-6.035,1.676a.938.938,0,1,0,.5,1.807l3.762-1.045-4.816,8.028a.937.937,0,0,0-.134.482,6.962,6.962,0,0,0,13.925,0,.936.936,0,0,0-.134-.482L57.4,16.569l14.625-4.062-4.816,8.028a.938.938,0,0,0-.134.482,6.962,6.962,0,0,0,13.925,0,.938.938,0,0,0-.134-.482Z",
  transform: "translate(-49 -1)",
  fill: "#191919",
  fillRule: "evenodd"
});

var SvgNav16 = function SvgNav16(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNav16, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/nav-16.ead5cf1f.svg";
export { ForwardRef as ReactComponent };